import React from "react";
import {injectIntl} from "react-intl";
import {Button, Card, Checkbox, Col,  Input, Modal, Row, Select, Spin, Form} from "antd";
import {getSpaces, initDeploy} from "./deployMarketApp";
import {initApplicationEdit} from "scenes/Application/ApplicationEdit/applicationEdit";

const FormItem = Form.Item;
const Option = Select.Option;
const {TextArea} = Input;
const confirm = Modal.confirm;

class DeployMarketAppComponent extends React.Component {
  formRef = React.createRef();

  componentWillMount() {
  }

  componentDidMount() {
    let res = this.props.location.search.split(/[?=&]/);
    console.log(res);
    this.props.dispatch(initDeploy({
      appVersionId: res[2] || this.props.appVersionId,
      appPlanId: res[4] || this.props.appPlanId,
      // appPeriodId: this.props.location.query.period || this.props.appPeriodId
      periods: res[6] || this.props.periods,
      cost: res[8] || this.props.cost,
      enterprise: this.props.enterprise
    }));
  }

  onSubmitBeforeCheck = () => {
    this.formRef.current.validateFields().then(values => {
      values.applicationId = this.props.application.id;
      values.majorId = this.props.appVersion.majorVersion.id;
      values.minorId = this.props.appVersion.id;
      values.enterpriseId = "00000000-0000-0000-0000-000000000000";
      // values.enterpriseId = this.props.enterprise;
      values.other = "";
      values.month = this.props.periods;
      values.cost = this.props.cost;
      values.userId = this.props.userId;
      this.props.onSubmit(values, this.props.history);
    });
  };

  render() {
    return (
      <Spin spinning={this.props.loading} size="large">
        <Modal
          visible={this.props.modalVisible}
          title={this.props.modalTitle && this.props.intl.formatMessage({id: this.props.modalTitle})}
          okText={this.props.modalOk && this.props.intl.formatMessage({id: this.props.modalOk})}
          cancelText={this.props.modalCancel && this.props.intl.formatMessage({id: this.props.modalCancel})}
          onOk={this.props.onOk}
          onCancel={this.props.onCancel}
        >
          <p>{this.props.modalContent && this.props.intl.formatMessage({id: this.props.modalContent})}</p>
          {this.props.modalVisitUrl &&
            <p>应用购买成功，已成功运行，账户余额为{this.props.balance}</p>
          }
        </Modal>
        <Row type="flex" justify="center" style={{paddingTop: '32px'}}>
          <Col sm={24} md={20} lg={16}>
            <Form ref={this.formRef} name="deploy-app">
            <Card>
              {/*<Row>*/}
              {/*  <Col span={12}>*/}
              {/*    <h3>{this.props.intl.formatMessage({id: "deployMarketAppNameLabel"})}</h3>*/}
              {/*    <h4>{this.props.application && this.props.application.name}</h4>*/}
              {/*  </Col>*/}
              {/*  <Col span={12}>*/}
              {/*    <h3>英文名</h3>*/}
              {/*    <h4>{this.props.application.enName}</h4>*/}
              {/*    /!*<h4>{this.props.appVersion.majorVersion.application && this.props.appVersion.majorVersion.application.type.name}</h4>*!/*/}
              {/*  </Col>*/}
              {/*  <Col span={12}>*/}
              {/*    <h3>{this.props.intl.formatMessage({id: "deployMarketAppVersionLabel"})}</h3>*/}
              {/*    <h4>{this.props.appVersion.version && this.props.appVersion.version}</h4>*/}
              {/*  </Col>*/}
              {/*  <Col span={12}>*/}
              {/*    <h3>价格</h3>*/}
              {/*    <h4>{this.props.cost}</h4>*/}
              {/*    /!*<h4>{this.props.appVersion.majorVersion.application && this.props.appVersion.majorVersion.application.type.name}</h4>*!/*/}
              {/*  </Col>*/}
              {/*  {this.props.periods &&*/}
              {/*  <Col span={12}>*/}
              {/*    <h3>有效期</h3>*/}
              {/*    <h4>{this.props.runtimeStart + " — " + this.props.runtimeEnd}</h4>*/}
              {/*  </Col>*/}
              {/*  }*/}
              {/*  <Col span={12}>*/}
              {/*    <h3>发布公司</h3>*/}
              {/*    <h4>{this.props.application.createCompanyName}</h4>*/}
              {/*    /!*<h4>{this.props.appVersion.majorVersion.application && this.props.appVersion.majorVersion.application.type.name}</h4>*!/*/}
              {/*  </Col>*/}
              {/*  <Col span={12}>*/}
              {/*    <h3>应用发布日期</h3>*/}
              {/*    <h4>{this.props.application.createDate}</h4>*/}
              {/*    /!*<h4>{this.props.appVersion.majorVersion.application && this.props.appVersion.majorVersion.application.type.name}</h4>*!/*/}
              {/*  </Col>*/}
              {/*  {this.props.periods &&*/}
              {/*    <Col span={12}>*/}
              {/*      <h3>有效期</h3>*/}
              {/*      <h4>{this.props.runtimeStart + " — " + this.props.runtimeEnd}</h4>*/}
              {/*    </Col>*/}
              {/*  }*/}
              {/*</Row>*/}
              <Row gutter={16} style={{paddingTop: 10}}>
                <Col span={12}>
                  <strong>{this.props.intl.formatMessage({id: "deployMarketAppNameLabel"})}</strong>
                  <p style={{marginTop: 10}}>{this.props.application.name}</p>
                </Col>
                <Col span={12}>
                  <strong>英文名</strong>
                  <p style={{marginTop: 10}}>{this.props.application.enName}</p>
                </Col>
              </Row>
              <Row gutter={16} style={{paddingTop: 10}}>
                <Col span={12}>
                  <strong>{this.props.intl.formatMessage({id: "deployMarketAppVersionLabel"})}</strong>
                  <p style={{marginTop: 10}}>{this.props.appVersion.version}</p>
                </Col>
                <Col span={12}>
                  <strong>价格</strong>
                  <p style={{marginTop: 10}}>{this.props.cost}</p>
                </Col>
              </Row>
              <Row gutter={16} style={{paddingTop: 10}}>
                <Col span={12}>
                  <strong>发布公司</strong>
                  <p style={{marginTop: 10}}>{this.props.application.createCompanyName}</p>
                </Col>
                <Col span={12}>
                  <strong>应用创建时间</strong>
                  <p style={{marginTop: 10}}>{this.props.application.createDate}</p>
                </Col>
              </Row>
              <Row gutter={16} style={{paddingTop: 10}}>
                <Col span={12}>
                  <strong>使用周期</strong>
                  <p style={{marginTop: 10}}>{this.props.periods}月</p>
                </Col>
                <Col span={12}>
                  <strong>有效期</strong>
                  <p style={{marginTop: 10}}>{this.props.runtimeStart + " — " + this.props.runtimeEnd}</p>
                </Col>
              </Row>
              <Row gutter={16} style={{paddingTop: 10}}>
                <Col span={12}>
                  <strong>您的企业</strong>
                  <p style={{marginTop: 10}}>{this.props.enterpriseName}</p>
                </Col>
                <Col span={12}>
                  <strong>您的租户空间</strong>
                  <p style={{marginTop: 10}}>{this.props.namespace?this.props.namespace.name:"您还未申请租户空间，请先申请租户空间"}</p>
                </Col>
              </Row>
                {/*{this.props.users &&*/}
                {/*<Col span={8}>*/}
                {/*  <h3>用户并发数</h3>*/}
                {/*  <h4>{this.props.users}位</h4>*/}
                {/*</Col>*/}
                {/*}*/}
              <Row gutter={16} style={{paddingTop: 10}}>
                <Col span={12}>
                  <strong>数据库地址</strong>
                  <Form.Item
                    name="host"
                    rules={[
                      {
                        required: true,
                        message: "请输入数据库连接地址",
                      },
                    ]}
                  >
                    <Input/>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <strong>数据库</strong>
                  <Form.Item
                    name="database"
                    rules={[
                      {
                        required: true,
                        message: "请输入数据库名",
                      },
                    ]}
                  >
                    <Input/>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16} style={{paddingTop: 10}}>
                <Col span={8}>
                  <strong>用户名</strong>
                  <Form.Item
                    name="username"
                    rules={[
                      {
                        required: true,
                        message: "请输入数据库用户名",
                      },
                    ]}
                  >
                    <Input/>
                  </Form.Item>
                </Col>
                <Col span={10}>
                  <strong>密码</strong>
                  <Form.Item
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: "请输入数据库密码",
                      },
                    ]}
                  >
                    <Input/>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <strong>端口</strong>
                  <Form.Item
                    name="port"
                    rules={[
                      {
                        required: true,
                        message: "请输入数据库连接端口",
                      },
                    ]}
                  >
                    <Input/>
                  </Form.Item>
                </Col>
              </Row>
            </Card>
            {/*<Row>*/}
            {/*  <Col span={10} offset={1}>*/}
            {/*    /!*<FormItem label={this.props.intl.formatMessage({id: "deployMarketAppSpaceLabel"})}>*!/*/}
            {/*    <Form.Item*/}
            {/*      name="enterpriseId"*/}

            {/*      rules={[*/}
            {/*        {*/}
            {/*          required: true,*/}
            {/*          message: "请选择部署企业！",*/}
            {/*        },*/}
            {/*      ]}*/}
            {/*    >*/}
            {/*        <Select name="enterpriseId"*/}
            {/*          // placeholder={this.props.intl.formatMessage({id: "deployMarketAppSpacePlaceholder"})}*/}
            {/*                placeholder="您的企业"*/}
            {/*                style={{width: "100%"}}*/}
            {/*                onChange={value => {*/}
            {/*                  // this.props.form.setFieldsValue({spaceId: null});*/}
            {/*                  this.props.form.resetFields(["spaceId"]);*/}
            {/*                  this.props.dispatch(getSpaces(value))*/}
            {/*                }}*/}
            {/*                onFocus={()=>{*/}
            {/*                  if(!this.props.isAuthenticated){*/}
            {/*                    this.props.handleLoginClick();*/}
            {/*                  }*/}
            {/*                }}>*/}
            {/*          {this.props.enterprises && this.props.enterprises.map(t => {*/}
            {/*            return (*/}
            {/*              <Option key={t.id} value={t.id}>{t.name}</Option>*/}
            {/*            )*/}
            {/*          })}*/}
            {/*        </Select>*/}
            {/*      )}*/}
            {/*    </Form.Item>*/}
            {/*  </Col>*/}
            {/*  <Col span={10} offset={2}>*/}
            {/*    /!*<FormItem label={this.props.intl.formatMessage({id: "deployMarketAppSpaceLabel"})}>*!/*/}
            {/*    <Form.Item*/}
            {/*      name="spaceId"*/}
            {/*      label="部署空间"*/}
            {/*      rules={[*/}
            {/*        {*/}
            {/*          required: true,*/}
            {/*          message: "请选择部署空间！",*/}
            {/*        },*/}
            {/*      ]}*/}
            {/*    >*/}
            {/*        <Select placeholder={<span><Spin spinning={this.props.updating}*/}
            {/*                                         size="small"/>{this.props.intl.formatMessage({id: "deployMarketAppSpacePlaceholder"})}</span>}*/}
            {/*                style={{width: "100%"}}>*/}
            {/*          {this.props.spaces.map(t => {*/}
            {/*            return (*/}
            {/*              <Option key={t.id} value={t.id}>{t.name}</Option>*/}
            {/*            )*/}
            {/*          })}*/}
            {/*        </Select>*/}
            {/*      )}*/}
            {/*    </Form.Item>*/}
            {/*  </Col>*/}
            {/*</Row>*/}
            <Row>
              <Col span={24}>
                <Button type="primary" onClick={this.onSubmitBeforeCheck} disabled={!this.props.namespace}>
                  {this.props.intl.formatMessage({id: "deployMarketAppConfirmBuyLabel"})}
                </Button>
                <Button type="primary" onClick={() => this.props.onReturn()}>
                  {this.props.intl.formatMessage({id: "deployMarketAppCancelLabel"})}
                </Button>
                <Button type="link"  onClick={()=>{window.open("/console/initialize-tenant-space");}}>跳转租户空间</Button>
              </Col>
            </Row>
            </Form>
          </Col>
        </Row>
      </Spin>
    );
  }
}

// DeployMarketAppComponent = Form.create()(DeployMarketAppComponent);
export default injectIntl(DeployMarketAppComponent);
